export default {
	BLACK: "BLACK",
	BROWN: "BROWN",
	DARKBLUE: "DARKBLUE",
	DARKGREEN: "DARKGREEN",
	DARKRED: "DARKRED",
	GRAY: "GRAY",
	LIGHTBLUE: "LIGHTBLUE",
	LIGHTGREEN: "LIGHTGREEN",
	LIGHTRED: "LIGHTRED",
	MAGENTA: "MAGENTA",
	ORANGE: "ORANGE",
	PURPLE: "PURPLE",
	SALMON: "SALMON",
	VIOLET: "VIOLET",
	YELLOW: "YELLOW",
	WHITE: "WHITE"
};
